import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_INPUT_SCHEMA = Object.freeze({
  INPUT_ID: null,
  INPUT_LOCAL_ID: '',
  INPUT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_INPUT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_INPUT_SCHEMA);

export class InputTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.input;
  }

  get properties() {
    return this.toJS();
  }
}
